/**
 * Topographic contour lines — brand texture, drawn from the trail metaphor.
 *
 * These used to sit behind the light hero at roughly 10% effective opacity,
 * where they contributed a washed green cast and no structure. The rule now is
 * commit or remove: they run at full strength inside a Brand Ink band, where
 * they read as topography, and nowhere else.
 *
 * Absolutely positioned; the parent needs `relative` and `overflow-hidden`.
 */
interface TopoLinesProps {
  /** 0 to 1. Tuned for a Brand Ink ground; do not use below ~0.25. */
  opacity?: number;
  className?: string;
}

const TopoLines = ({ opacity = 0.4, className = "" }: TopoLinesProps) => (
  <svg
    aria-hidden
    className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
    style={{ opacity }}
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    viewBox="0 0 800 600"
  >
    <defs>
      <pattern id="topo-lines" x="0" y="0" width="160" height="120" patternUnits="userSpaceOnUse">
        <path d="M0 60 Q40 20 80 60 T160 60" fill="none" stroke="hsl(var(--trail-teal))" strokeWidth="1" />
        <path d="M0 90 Q40 50 80 90 T160 90" fill="none" stroke="hsl(var(--trail-teal))" strokeWidth="1" />
        <path d="M0 30 Q40 -10 80 30 T160 30" fill="none" stroke="hsl(var(--trail-teal))" strokeWidth="1" />
      </pattern>
    </defs>
    <rect width="800" height="600" fill="url(#topo-lines)" />
  </svg>
);

export default TopoLines;
